<template>
  <div>
    <section class="activity-stage">
      <img :src="currentRound.image" v-if="currentRound.image" />
      <div id="steps">
        <text-display-list id="input" text-size="medium">
          <blinking-cursor-text
            v-for="step in currentRound.steps"
            :key="`step${step.stepIndex}`"
            :text="step.answer"
            :text-step="step.stepIndex"
          ></blinking-cursor-text>
        </text-display-list>
      </div>
      <slot name="keyboard"></slot>
    </section>
  </div>
</template>

<script>
import { TweenMax, TimelineLite } from 'gsap';

import AssetLoader from 'mixins/AssetLoader';
import ErrorLogger from 'mixins/ErrorLogger';
import TypingActivityHelper from 'mixins/TypingActivityHelper';
import ActivityManager from 'mixins/ActivityManager';

import BlinkingCursorText from 'components/text-displays/BlinkingCursorText.vue';
import TextDisplayList from 'components/text-displays/TextDisplayList.vue';

export default {
  mixins: [AssetLoader, TypingActivityHelper, ActivityManager, ErrorLogger],
  components: {
    BlinkingCursorText,
    TextDisplayList
  },
  data() {
    return {
      activityName: 'Math Sentences'
    };
  },

  methods: {
    getActivityState() {
      const { rounds } = this.activityData;

      return {
        rounds,
        instructions: {
          written: 'Type every math sentence.',
          voice: `${this.voiceInstructionsPrefix}/mathsentences-${this.getRandomVoice()}-1.mp3`,
          delay: 3
        }
      };
    },

    async loadActivity() {
      const roundSetup = this.getActivityState();
      this.createRounds(roundSetup);
      await this.loadImages();
    },

    async loadImages() {
      this.rounds.forEach(({ image }) => {
        this.queueImage(image);
      });

      return this.downloadImages();
    },

    getKeyboardConfig() {
      const { keyboardType, roofs } = this.activityData.keyboard;
      return {
        keyboardType,
        hideNumberRow: false,
        roofs
      };
    },

    startActivity() {
      this.setRound();
    },

    setRound() {
      this.setupNewRound();
      this.enableKeyboard();
      this.errorLoggerStart();
      this.$nextTick(() => {
        TweenMax.to('.activity-stage', 0.5, { opacity: 1 });
      });
    },

    handleCorrectKey() {
      this.incrementTypingIndex();
      this.sndType();

      if (this.isEndOfCurrentSentence) {
        this.sndBell();
        this.setCurrentStep();
      }

      if (this.isEndOfRound) {
        this.handleRoundEnd();
      }
    },

    handleRoundEnd() {
      const t = new TimelineLite();

      t.delay(0.8).call(() => {
        if (this.isLastRound) {
          TweenMax.delayedCall(0.8, this.completeActivity);
        } else {
          t.delay(1)
            .to('.activity-stage', 0.8, { opacity: 0 })
            .call(this.setRound);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
div:first-of-type {
  margin: 0px auto 5% auto;

  img {
    width: 32%;
    float: left;
  }
  #steps {
    width: 62%;
    margin: 0px 1% 8% 1%;
    float: right;
    ul,
    p {
      margin: 0;
      padding: 0;
    }
  }
}
</style>
